import { skipNext } from "../IntroVideoControl/IntroVideoControl";
import IconButton from "../../UI/IconButton/IconButton";
const SkipNarrationBtn = ({ onSkip }) => {
  return (
    <div
      style={{
        color: "#fff",
        textTransform: "none",
        position: "absolute",
        top: "20px",
        right: "10px",
        "&:hover": {
          borderColor: "#4a4e55",
          background: "#1c1e22",
        },
      }}
    >
      <IconButton
        edge="end"
        color="inherit"
        className="icon"
        aria-label="Profile and achievements"
        onClick={onSkip}
        imageSrc={skipNext}
        title={"Skip"}
      />
    </div>
  );
};
export default SkipNarrationBtn;
